// import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import Home from './Home/Home';
// import Login from './Login/Login';
// import ManageUsers from './Component/Pages/ManageUsers/ManageUsers';
// import NotificationsPage from './Header/Notification/Notification';
// import SignUp from './Component/Register/Signup';
// import EventSection from './Component/Pages/EventSection/EventSection';
// import Committee from './Component/Pages/Committee/Committee';
// import Notice from './Component/Pages/Notice/Notice';
// import Blog from './Component/Pages/Blog/Blog';
// import Gallery from './Component/Pages/Gallery/Gallery';
// import AboutUs from './Component/Pages/AboutUs/AboutUs';
// import AdminDetails from "./context/adminDetailsContext";
// import { useState, useEffect } from 'react';
// import { Toaster } from 'react-hot-toast';
// import Cookies from 'js-cookie';
// import Course from './Component/Pages/Courses/Courses';
// import CourseDetails from './Component/Pages/Courses/CourseDetails';
// import SuperAdminDashboard from './Component/Pages/SuperAdmin/SuperAdminDashboard';
// import AuthChecker from './AuthChecker'; // Import the checker
// import SuperAdminGuard from './Component/Pages/SuperAdmin/SuperAdminGaurd';

// // 👇 NEW IMPORTS for additional super admin pages
// import CollegeManagement from './Component/Pages/SuperAdmin/CollegeManagement';
// import PendingApprovals from './Component/Pages/SuperAdmin/PendingApproval';
// import UserManagement from './Component/Pages/SuperAdmin/UserManagement';
// import Posts from './Component/Pages/Posts/Posts';

// function App() {
//   const [details, setDetails] = useState([]);

//   return (
//     <AuthChecker> {/* Wrap everything with AuthChecker */}
//       <BrowserRouter>
//         <AdminDetails.Provider value={{ details, setDetails }}>
//           <Toaster position="top-center" />
//           <Routes>
//             {/* Public Routes */}
//             <Route path="/login" element={<Login />} />
//             <Route path="/signup" element={<SignUp />} />

//             {/* Regular Admin Routes */}
//             <Route path="/" element={<Home />} />
//             <Route path="/home" element={<Home />} />
//             <Route path="/manage-user" element={<ManageUsers />} />
//             <Route path="/events" element={<EventSection />} />
//             <Route path="/notifications" element={<NotificationsPage />} />
//             <Route path="/committee" element={<Committee />} />
//             <Route path="/notice" element={<Notice />} />
//             <Route path="/blog" element={<Blog />} />
//             <Route path="/gallery" element={<Gallery />} />
//             <Route path="/about-us" element={<AboutUs />} />
//             <Route path="/posts" element={<Posts />} />
//             <Route path='/courses' element={<Course />} />
//             <Route path="/admin/course/:type/:id" element={<CourseDetails />} />

//             {/* Super Admin Routes */}
//             <Route path="/dashboard" element={ 
//               <SuperAdminGuard>
//                  <SuperAdminDashboard />
//               </SuperAdminGuard>
//             } />

//             {/* 👇 NEW SUPER ADMIN ROUTES - ADDED BELOW */}
//             <Route path="/super-admin/pending" element={
//               <SuperAdminGuard>
//                 <PendingApprovals />
//               </SuperAdminGuard>
//             } />

//             <Route path="/super-admin/colleges" element={
//               <SuperAdminGuard>
//                 <CollegeManagement />
//               </SuperAdminGuard>
//             } />

//             <Route path="/super-admin/users" element={
//               <SuperAdminGuard>
//                 <UserManagement />
//               </SuperAdminGuard>
//             } />

//             {/* <Route path="/super-admin/settings" element={
//               <SuperAdminGuard>
//                 <Settings />
//               </SuperAdminGuard>
//             } /> */}
//           </Routes>
//         </AdminDetails.Provider>
//       </BrowserRouter>
//     </AuthChecker>
//   );
// }

// export default App;










import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Home/Home';
import Login from './Login/Login';
import ManageUsers from './Component/Pages/ManageUsers/ManageUsers';
import NotificationsPage from './Header/Notification/Notification';
import SignUp from './Component/Register/Signup';
import EventSection from './Component/Pages/EventSection/EventSection';
import Committee from './Component/Pages/Committee/Committee';
import Notice from './Component/Pages/Notice/Notice';
import Blog from './Component/Pages/Blog/Blog';
import Gallery from './Component/Pages/Gallery/Gallery';
import AboutUs from './Component/Pages/AboutUs/AboutUs';
import AdminDetails from "./context/adminDetailsContext";
import { useState, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import Cookies from 'js-cookie';
import Course from './Component/Pages/Courses/Courses';
import CourseDetails from './Component/Pages/Courses/CourseDetails';
import SuperAdminDashboard from './Component/Pages/SuperAdmin/SuperAdminDashboard';
import AuthChecker from './AuthChecker';
import SuperAdminGuard from './Component/Pages/SuperAdmin/SuperAdminGaurd';
import CollegeManagement from './Component/Pages/SuperAdmin/CollegeManagement';
import PendingApprovals from './Component/Pages/SuperAdmin/PendingApproval';
import UserManagement from './Component/Pages/SuperAdmin/UserManagement';
import Posts from './Component/Pages/Posts/Posts';
import Courses from './Component/Pages/SuperAdmin/Courses';
import Events from './Component/Pages/SuperAdmin/Events';

// Simple NotFound component
const NotFound = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-50">
    <div className="text-center">
      <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
      <p className="text-xl text-gray-600 mb-6">Page not found</p>
      <a href="/login" className="text-blue-600 hover:underline">Go to Login</a>
    </div>
  </div>
);

function App() {
  const [details, setDetails] = useState([]);

  return (
    <BrowserRouter>
      <AdminDetails.Provider value={{ details, setDetails }}>
        <Toaster position="top-center" />
        <AuthChecker> {/* AuthChecker inside BrowserRouter */}
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />

            {/* Regular Admin Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/manage-user" element={<ManageUsers />} />
            <Route path="/events" element={<EventSection />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/committee" element={<Committee />} />
            <Route path="/notice" element={<Notice />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/posts" element={<Posts />} />
            <Route path='/courses' element={<Course />} />
            <Route path="/admin/course/:type/:id" element={<CourseDetails />} />

            {/* Super Admin Routes */}
            <Route path="/dashboard" element={
              <SuperAdminGuard>
                <SuperAdminDashboard />
              </SuperAdminGuard>
            } />

            <Route path="/super-admin/pending" element={
              <SuperAdminGuard>
                <PendingApprovals />
              </SuperAdminGuard>
            } />

            <Route path="/super-admin/colleges" element={
              <SuperAdminGuard>
                <CollegeManagement />
              </SuperAdminGuard>
            } />

            <Route path="/super-admin/users" element={
              <SuperAdminGuard>
                <UserManagement />
              </SuperAdminGuard>
            } />

            <Route path="/super-admin/courses" element={
              <SuperAdminGuard>
                <Courses />
              </SuperAdminGuard>
            } />
            <Route path='/super-admin/events' element={
              <SuperAdminGuard>
                <Events />
              </SuperAdminGuard>
            }/>

            {/* 404 Route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthChecker>
      </AdminDetails.Provider>
    </BrowserRouter>
  );
}

export default App;


